export default "__VITE_ASSET__UP1GVjKC__"